import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  active_customer: 0,
};

const dashBoardTotalActiveUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_TOTAL_ACTIVE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Roles fetch successfully",
        active_customer: action.payload.data,
      };
    case TYPE.GET_TOTAL_ACTIVE_CUSTOMER_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching roles",
        active_customer: 0,
      };

    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default dashBoardTotalActiveUserReducer;
